import { CircularProgress, Box } from "@material-ui/core";
import { Circles } from "react-loader-spinner";

interface Props {
  advanced: any;
}

export const Loader = (props: Props) => {
  const { advanced } = props;
  const color = localStorage.getItem("primaryColor") || "";

  return (
    <>
      {advanced ? (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Circles
            color={color}
            height={200}
            width={200}
            wrapperStyle={{
              display: "flex",
              alignItem: "center",
              justifyContent: "center",
              marginTop: "20%",
            }}
          />
        </Box>
      ) : (
        <Box
          sx={{
            display: "flex",
            alignContent: "center",
            marginTop: "10rem",
            marginLeft: "3rem",
            border: "3px solid yelllow",
          }}
        >
          <CircularProgress style={{ color: color }} />
        </Box>
      )}
    </>
  );
};
